import { Component, inject } from "@angular/core";
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
  FormsModule,
  ReactiveFormsModule
} from "@angular/forms";
import { SubDivisionStore } from "@app/services/store/roster/sub-division-store";
import { SubDivision } from "@app/models/rest/roster/sub-division";
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions
} from "@angular/material/dialog";
import { Roster } from "@app/models/rest/roster/roster";
import { CdkScrollable } from "@angular/cdk/scrolling";
import { MatFormField, MatLabel, MatError } from "@angular/material/form-field";
import { MatInput } from "@angular/material/input";
import { MatButton } from "@angular/material/button";
import { DialogHeaderComponent } from "../../../../shared/dialog-header/dialog-header.component";

@Component({
  selector: "app-add-division-dialog",
  templateUrl: "./add-division-dialog.component.html",
  styleUrls: ["./add-division-dialog.component.css"],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CdkScrollable,
    MatDialogContent,
    MatFormField,
    MatLabel,
    MatInput,
    MatError,
    MatDialogActions,
    MatButton,
    DialogHeaderComponent
  ]
})
export class AddDivisionDialogComponent {
  protected divisionStore = inject(SubDivisionStore);
  dialogRef = inject<MatDialogRef<AddDivisionDialogComponent>>(MatDialogRef);
  data = inject<{
    roster: Roster;
  }>(MAT_DIALOG_DATA);

  divisionForm = new UntypedFormGroup({
    name: new UntypedFormControl("", Validators.required)
  });

  cancel() {
    this.dialogRef.close();
  }

  submit() {
    console.log("submitting", this.divisionForm.value);
    let subDivision = new SubDivision();
    subDivision.name = this.divisionForm.value.name;
    subDivision.roster = this.data.roster;
    this.divisionStore.create(subDivision).subscribe((value) => {
      this.dialogRef.close();
    });

    // this.data.roster.addRelation('subDivisions', subDivision).subscribe(value => {});
    // this.divisionStore.create(this.divisionForm.value).subscribe(value => {});
  }
}
